module.exports = __webpack_public_path__ + "img/ecopayz.0d513abf.svg";